import { HANDLE_POINT_ADDRESS, RESET } from '../actions';

const initialState = {
    pointAddressList: [],
    pointAddressCopy: [],
    search: "",
    vehicleFilter: ""
};

const PointAddressDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_POINT_ADDRESS:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default PointAddressDetails;